<div class="pseic-form-error-container" [class.pseic-form-error-container__no-resize]="!resizeOnError"
     [attr.data-testid]="dataTestId"
>
  <div
    class="o-form-msg o-form-msg--danger"
    *ngIf="control?.errors  && (control?.touched || control?.dirty)"
  >
    <psei-icon
      name="circle-dismiss"
      size="S"
      class="o-form-msg__icon"
    ></psei-icon>
    <ng-container *ngIf="!control.errors.required && !control.errors.email; else elseRequired">
      <div *ngIf="!multipleErrors; else multipleErrorsTemplate"
           class="o-form-msg__text"
           [pseiLineClamp]="2"
           [lineClampText]="control.errors?.message"
      >
        {{control.errors?.message}}
      </div>
      <ng-template #multipleErrorsTemplate>
        <div
          *ngFor="let error of control.errors | keyvalue"
          class="o-form-msg__text"
          [pseiLineClamp]="2"
          [lineClampText]="error.value?.message"
        >
          {{error.value?.message}}
        </div>
      </ng-template>
    </ng-container>
    <ng-template #elseRequired>
      <div
        *ngIf="control.errors.required"
        class="o-form-msg__text error-message-text"
        [pseiLineClamp]="2"
        [lineClampText]="requiredField"
        i18n="@@shared.required_field"
      >
        To pole jest wymagane
      </div>
      <div
        *ngIf="control.errors.email"
        class="o-form-msg__text error-message-text"
        [pseiLineClamp]="2"
        [lineClampText]="invalidEmail"
        i18n="@@shared.invalid_email"
      >
        Niepoprawny adres e-mail
      </div>
    </ng-template>
  </div>
</div>
